

const __request = require(`@/lib/data-service/default/__request/__request_contentType_form`);

// 迪风云订单确认： http://219.128.52.2:9999/doc.html#/%E6%89%80%E6%9C%89%E6%8E%A5%E5%8F%A3/platform-order-controller/platformDfyOrderAuditListUsingPOST
export default function web_salesOrder_platformDfyOrderAuditList(pParameter) {
  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/web/salesOrder/platformDfyOrderAuditList';
  params.data = pParameter;
  
  return new Promise(function(resolve, reject) {
    resolve(__request(params))
  })
}
